import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useLazyQuery } from 'react-apollo'

import { useCart } from '../../CartProvider/CartProvider'
import { useRestaurant } from '../../RestaurantProvider/RestaurantProvider'

import { SELECTION_ITEM_DETAILS } from '../../../apollo/menu/menuitem.graphql'
import { useEditItemInCart } from '../../CartMutation/CartMutation'

import { UpdateItemFormModal } from '../UpdateItemFormModal/UpdateItemFormModal'
import { useFulfillment } from '../../FulfillmentProvider/FulfillmentProvider'
import { useNestedModifiers } from '../use-nested-modifiers'
import { useOutpostRestaurant } from '../../OutpostProvider/OutpostProvider'

export const EditItem = ({
  itemGuid,
  itemGroupGuid,
  onClose,
  selectionGuid
}) => {
  const { cartGuid } = useCart()
  const { shortUrl } = useRestaurant()
  const { fulfillmentTime, loading } = useFulfillment()
  const { outpostDeliveryDateTime } = useOutpostRestaurant()
  const dateTime = outpostDeliveryDateTime || fulfillmentTime || undefined
  const { nestingLevel } = useNestedModifiers()

  const [getSelectionItemDetails, itemDetailsQuery] = useLazyQuery(SELECTION_ITEM_DETAILS, {
    notifyOnNetworkStatusChange: true,
    // no cache instead of cache-and-network
    // because of: https://github.com/apollographql/react-apollo/issues/3361
    fetchPolicy: 'no-cache',
    variables: {
      input: { shortUrl, itemGuid, itemGroupGuid, selectionGuid, cartGuid, dateTime },
      nestingLevel
    }
  })

  const [editItemInCart, { error }] = useEditItemInCart({ onCompleted: onClose })

  useEffect(() => {
    if (!loading) getSelectionItemDetails()
  }, [getSelectionItemDetails, loading])

  const getItemDetails = (data = {}) => {
    const { selectionItemDetails } = data
    if (!selectionItemDetails) return null

    const { fractionalQuantity = {} } = selectionItemDetails
    const { unitOfMeasure = '' } = fractionalQuantity

    return {
      ...selectionItemDetails,
      // usesFractionalQuantity comes from selectionItemDetails
      unitOfMeasure,
      fractionalQuantity
    }
  }

  const getBasePrice = (data = {}) => (data.selectionItemDetails && data.selectionItemDetails.menuItemPrice) || 0

  return (
    <UpdateItemFormModal
      updateCart={editItemInCart}
      error={error}
      itemDetailsQuery={itemDetailsQuery}
      getItemDetails={getItemDetails}
      getBasePrice={getBasePrice}
      onClose={onClose}
      itemGuid={itemGuid}
      itemGroupGuid={itemGroupGuid}
      selectionGuid={selectionGuid}
      mayDelete
    />
  )
}

EditItem.propTypes = {
  itemGuid: PropTypes.string.isRequired,
  itemGroupGuid: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  selectionGuid: PropTypes.string.isRequired
}
